import { createReducer, on } from '@ngrx/store';
import { IInvitation } from '../model/invitation.model';
import { InvitationsState } from './invitations.state';
import { invitationsActions } from './invitations.actions';

export const initialInvitationsState: InvitationsState = {
  pendingRequests: [] as IInvitation[]
};
 
export const invitationsReducer = createReducer(
    initialInvitationsState,
    on( invitationsActions.requestInvitationSentSuccess, (state , { invitation }) => ({ 
      ...state, 
      pendingRequests: [...state.pendingRequests, invitation]
    })),
    on( invitationsActions.getPendingRequestsSuccess, (state , { invitations }) => ({ 
      ...state, 
      pendingRequests: invitations
    })),
    on( invitationsActions.cancelRequestInvitationSentSuccess, (state , { invitation }) => ({ 
      ...state, 
      pendingRequests: [...state.pendingRequests.filter(x => x.email !== invitation.email)]
    })),
);
